import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsSatisfactionTimeScaleRoute: InvariantJiraRoute = {
	name: 'servicedesk-reports-satisfaction-time-scale',
	path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId',
};
